/**
 * @content 智石标准插件2.0，用户行为数据上报JS SDK
 * @version 1.0
 * @date 2019.07.31
 */
import {updataHOST} from "./../config/config"
function UserOperInfoHelper(){
    this.HOST = updataHOST;
    this.bi = "";
    this.ui = "";
    this.ai = "";
    this.f = 0;
    this.user = {};
    this.srouce = {};
    this.vt = {};
    this.xys = [];
    this.shl = [];
    this.sel = [];
    this.index = 1;
    this.rl = []; //路线
    this.nl = []; //导航
    this.ntl = []; //导航时间
    this.scl = [];
    this.tal = [];
    this.search = {};
    this.routeCalculate = {};
    this.searchCar = {};
    this.themeActivities = {};
    this.uploadIndex = 1; //数据上报临时参数，当此值大于等于3时上报
    this.locationCount = 0; //定位成功次数
    this.mapOpenCount = 0; //地图打开次数

    /**
     *
     * 每进入一次标准插件即产生一次（刷新页面不需要调用，单需要检车是否存在值）
     *
     * @param {Object} _bi 建筑ID
     * @param {Object} _ui 用户ID
     */
    this.init = function(_bi, _ui,_ai){

        if(!_bi || !_ui) return;

        this.bi = _bi;
        this.ui = _ui;

        let upstate = 1;    //0开启轮询上报 1：立即开启上报&轮询

        if(_ai){

            this._ai = _ai;
            upstate = 0;

        }else{

            //生成批次
            this.ai = "a_" + new Date().getTime();
            this.f = 1;

        }

        var sender = this;
        setTimeout(function(){
            sender.send(upstate);
        }, 800);

    }

    /**
     * 设置用户信息
     *
     * @param {Object} _n 名称/昵称
     * @param {Object} _h 头像地址
     * @param {Object} _s 性别(1:男；2:女；0:未知)
     * @param {Object} _a 年龄
     * @param {Object} _c 城市
     * @param {Object} _add 详细地址
     */
    this.setUser = function(_n, _h, _s, _a, _c, _add){
        this.user = {
            n:_n,
            hi:_h,
            se:_s,
            a:_a,
            c:_c,
            ad:_add,
            i:this.ui
        }
    }

    /**
     * 设置用户来源信息（1：分享；2：其他）
     * _t 来源类型
     * i 来源ID
     */
    this.setSource = function(_t, i){
        this.srouce = {
            t:_t,
            i:i
        }
    }

    /**
     * 设置访问端信息
     *
     * b：品牌
     * m：手机型号
     * w：浏览器信息
     * s：操作系统
     * a：app信息
     */
    this.setVisitTerminal = function(b, m, w, s, a){
        this.vt = {
            b:b,
            m:m,
            w:w,
            s:s,
            a:a
        }
    }

    /**
     * 设置定位信息
     * 	_x X坐标
     *  _y Y坐标
     *  _f 楼层号
     * _pi 所属POIID
     */
    this.setLocation = function(_x, _y, _f, _pi){
        this.xys.push({x:_x, y:_y, f:_f, pi:_pi});
    }

    /**
     * 设置分享信息
     * _shi 分享标识
     * _ty 分享业务类型(1：主题活动；2：店铺活动；3：其他页面；4：POI)
     * _oi 分享业务ID (主题活动页面ID/店铺活动页面ID/其他页面ID/POIID)
     */
    this.setShare = function(_shi, _ty, _oi){
        if(!_shi){
            _shi = "sh_"+this.ui+"_"+this.getTempId();
        }
        this.shl.push({shi:_shi, ty:_ty, oi:_oi});

        if(this.themeActivities && this.themeActivities.i && this.themeActivities.oi){
            if(this.themeActivities.oi === _oi){

            }
        }

        return _shi;
    }

    /**
     * 设置检索信息
     *
     * _t 类型(1:页面; 2:搜索)
     * _sv 搜索内容
     * _pi 选择结果POIID
     *
     * 返回本次检索的临时id，用于识别该搜索是否进行路网规划及导航
     */
    this.setSearch = function(_t, _sv, _pi){
        if(_t == 1){
            this.sel.push({i:"", t:1});
        }else{
            this.search = {i:"se_"+this.getTempId(), t:_t, sv:_sv, pi:_pi?_pi:""}
            this.sel.push(this.search);
        }
    }

    /**
     * 设置路网规划信息
     *
     * _s 起点信息 {x:x,y:y,f:floorNumber,pi:POIID}
     * _e 终点信息 {x:x,y:y,f:floorNumber,pi:POIID}
     * _t 类型(1：人；2：车)
     * ot 业务类型（1：电梯；2：扶梯；3：楼梯；4：其他）
     */
    this.setRouteCalculate = function(_s, _e, _t, _ot){
        if(!_s || !_e){
            console.log("setRouteCalculate error: startPoint or endPorint is error.");
            return;
        }
        var st = "";//来源类型 (普通搜索、车辆搜索)
        var si = "";//来源ID
        //校验是否为检索出来的结果进行路网规划
        if(this.search && this.search.pi){
            if(this.search.pi === _s.pi || this.search.pi === _e.pi){
                st = "se";
                si = this.search.i;
            }
        }
        //校验是否为寻车导航
        if(this.searchCar && this.searchCar.pi){
            if(this.searchCar.pi === _s.pi || this.searchCar.pi === _e.pi){
                st = "sc";
                si = this.searchCar.i;
            }
        }

        this.routeCalculate = {
            rt:1,
            rci:"rc_"+this.getTempId(),
            st:st,
            si:si,
            s:_s,
            e:_e,
            t:_t,
            ot:_ot
        };

        this.rl.push(this.routeCalculate);

        return this.routeCalculate.rci;
    }

    /**
     * 打开地图成功
     */
    this.setMapOpenSuccess = function(){
        this.mapOpenCount++;
    }

    /**
     * 定位成功
     */
    this.setLocationSuccess = function(){
        this.locationCount++;
    }

    /**
     * 设置开始导航
     * _nt 导航类型（1：正常导航；2：模拟导航）
     * _nft 导航楼层类型 （1：跨楼层导航；2：同楼层导航；3：其他）
     * _d 距离
     */
    this.setNavStart = function(_nt, _nft, _d){
        this.nl.push({rt:2, rci:this.routeCalculate.rci,nt:_nt,nft:_nft, d:_d});
    }

    /**
     * 开起导航监听(导航中每1-3秒调用此方法)
     */
    this.setNavListener = function(){
        this.ntl.push(this.routeCalculate.rci+"-"+parseInt(new Date().getTime()/1000));
    }


    /**
     * 导航结束
     */
    this.setNavOver = function(){
        this.nl.push({rt:3, rci:this.routeCalculate.rci});
    }

    /**
     * 设置寻车
     * _t 类型(1：页面；2：搜索)
     * _v 检索内容（如：渝B12345）
     * _pi 检索结果POIID
     */
    this.setSearchCar = function(_t, _v, _pi){
        if(_t == 1){
            this.scl.push({i:"", t:1});
        }else{
            if(_pi){
                this.searchCar = {i:"sc_"+this.getTempId(), t:2, v:_v, pi:_pi, s:1};
                this.scl.push(this.searchCar);
            }else{
                this.scl.push({i:"", t:2, v:_v, s:2});
            }
        }
    }

    /**
     * 设置主题活动浏览信息
     * _t 页面类型 (1：主题活动；2：店铺活动 ....。)
     * _oi 活动ID （主题活动页面ID/店铺活动页面ID）
     * _on 活动名称
     */
    this.setThemeActivities = function(_t, _oi, _on){
        this.themeActivities = {t:_t, oi:_oi, ot:1, on:_on};
        this.tal.push(this.themeActivities);
    }

    /**
     * 设置主题活动浏览信息到底
     */
    this.setThemeActivitiesEnd = function(){
        if(this.themeActivities && this.themeActivities.oi){
            this.tal.push({t:this.themeActivities.t, oi:this.themeActivities.oi, ot:2});
        }
    }

    /**
     * 设置主题活动页面被分享
     * shi 分享信息标识
     * _t 页面类型 (1：主题活动；2：店铺活动 ....。)
     * _oi 页面ID （主题活动页面ID/店铺活动页面ID）
     */
    this.setThemeActivitiesShare = function(shi, _t, _oi){
        var _themeActivities = this.themeActivities;
        _themeActivities.shis = [];
        _themeActivities.shis.push(shi);
        _themeActivities.ot = 3;
        if(_t) _themeActivities.t = _t;
        if(_oi) _themeActivities.oi = _oi;
        this.tal.push(_themeActivities)
    }

    this.getUserOperInfo = function(){
        if(this.bi && this.ai && this.ui){
            var isOper = false;
            var data = {};
            if(this.f == 1) data.f = this.f;
            data.bi = this.bi;
            data.ai = this.ai;
            data.ui = this.ui;
            data.lc = this.locationCount;
            data.moc = this.mapOpenCount;
            if(this.user && this.user.i){isOper = true;data.u = this.user;} else data.u = {};
            if(this.srouce && this.srouce.t){isOper = true;data.s = this.srouce;} else data.s = {};
            if(this.vt && this.vt.s){isOper = true;data.vt = this.vt;} else data.vt = {};
            if(this.xys && this.xys.length){data.xys = this.xys} else data.xys = [];
            if(this.shl && this.shl.length){isOper = true;data.shl = this.shl;} else data.shl = [];
            if(this.sel && this.sel.length){isOper = true;data.sel = this.sel;} else data.sel = [];
            if(this.rl && this.rl.length){isOper = true;data.rl = this.rl;} else data.rl = [];
            if(this.nl && this.nl.length){isOper = true;data.nl = this.nl;} else data.nl = [];
            if(this.ntl && this.ntl.length){isOper = true;data.ntl = this.ntl;} else data.ntl = [];
            if(this.scl && this.scl.length){isOper = true;data.scl = this.scl;} else data.scl = [];
            if(this.tal && this.tal.length){isOper = true;data.tal = this.tal;} else data.tal = [];
            if(!isOper && this.uploadIndex < 3){
                this.uploadIndex++;
                return undefined;
            }
            this.uploadIndex = 1;
            return data;
        }
        return undefined;
    }

    this.sendUserOperInfo = function(){
        this.send(0);
        var data = this.getUserOperInfo();
        if(data == undefined) return;
        var sendData = JSON.stringify(data);
        this.clearUploadData();
        var xmlhttp;
        if (window.XMLHttpRequest){
            // IE7+, Firefox, Chrome, Opera, Safari 浏览器执行代码
            xmlhttp=new XMLHttpRequest();
        }else{
            // IE6, IE5 浏览器执行代码
            xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
        }
        xmlhttp.open("POST", this.HOST+"/d/u/o?bi="+this.bi, true);
        xmlhttp.setRequestHeader("Content-type", "application/json;charset=utf-8");
        xmlhttp.send(sendData);
    }

    this.clearUploadData = function(){
        var sender = this;
        if(sender.f == 1) sender.f = 0;
        sender.locationCount = 0;
        sender.mapOpenCount = 0;
        sender.user = {};
        sender.srouce = {};
        sender.vt = {};
        sender.xys = [];
        sender.shl = [];
        sender.sel = [];
        sender.rl = [];
        sender.nl = [];
        sender.ntl = [];
        sender.scl = [];
        sender.tal = [];
    }


    this.send = function(i){
        var sender = this;
        if(i == 1){
            sender.sendUserOperInfo();
        }else{
            setTimeout(function(){
                sender.sendUserOperInfo();
            }, 3000);
        }
    }


    this.getTempId = function(){
        this.index++
        return this.index;
    }
}


export default UserOperInfoHelper;
